import React from 'react';

const InstagramIcon = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    role="img"
    aria-hidden="true"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="19.836"
    height="19.836"
    viewBox="0 0 19.836 19.836"
  >
    <path
      fill="currentColor"
      d="M9.918 1.788c2.648 0 2.962.01 4.009.058 2.688.122 3.943 1.4 4.066 4.066.048 1.046.057 1.36.057 4.008s-.01 2.962-.057 4.008c-.123 2.665-1.375 3.943-4.066 4.066-1.046.048-1.359.058-4.009.058s-2.962-.01-4.008-.058c-2.694-.123-3.943-1.4-4.066-4.066-.048-1.046-.058-1.359-.058-4.008s.014-2.963.059-4.01C1.968 3.243 3.22 1.967 5.91 1.845c1.047-.045 1.36-.057 4.008-.057Zm0-1.788C7.224 0 6.887.012 5.829.06 2.227.225.226 2.223.06 5.828.012 6.887 0 7.224 0 9.918s.012 3.032.06 4.09c.165 3.6 2.164 5.6 5.769 5.769 1.059.048 1.4.06 4.09.06s3.032-.012 4.09-.06c3.6-.165 5.605-2.164 5.768-5.769.049-1.058.06-1.4.06-4.09s-.012-3.031-.06-4.089c-.162-3.6-2.163-5.6-5.768-5.769C12.95.012 12.612 0 9.918 0Zm0 4.825a5.093 5.093 0 1 0 5.093 5.093 5.093 5.093 0 0 0-5.093-5.093Zm0 8.4a3.306 3.306 0 1 1 3.306-3.306 3.306 3.306 0 0 1-3.306 3.305Zm5.295-9.79A1.19 1.19 0 1 0 16.4 4.624a1.191 1.191 0 0 0-1.187-1.19Z"
      data-name="Path 62"
    />
  </svg>
);

export default InstagramIcon;
